import { MessagingHelper } from "../helpers/MessagingHelper";
import { PaginatedList } from "../helpers/PaginatedList";
import { DeliveryNoteEditDTO } from "../models/DeliveryNote/DeliveryNoteEditDTO";
import { DeliveryNoteSearchResultDTO } from "../models/DeliveryNote/DeliveryNoteSearchResultDTO";
import { DeliveryNoteUnsubmittedSearchResultDTO } from "../models/DeliveryNote/DeliveryNoteUnsubmittedSearchResultDTO";
import { Parameter } from "../models/Parameter";
import { APIService } from "./APIService";

export class DeliveryNoteService {
  async GetAll(
    searchParameters: Parameter[],
    sortingParameters: Parameter[],
    currentPage: number,
    pageSize: number
  ): Promise<PaginatedList<DeliveryNoteSearchResultDTO>> {
    try {
      var response = await APIService.Axios().post(
        `${APIService.GetURL()}/DeliveryNote/GetAllSubmited`,
        {
          searchParameters,
          sortingParameters,
          currentPage,
          pageSize,
        },
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + APIService.GetToken(),
          },
        }
      );
      return response.data;
    } catch (error) {
      return new PaginatedList<DeliveryNoteSearchResultDTO>(
        false,
        "Erro ao ligar ao servidor ao obter a informação das Guias de Transporte",
        "",
        [],
        0
      );
    }
  }

  async GetAllUnsubmitted(
    searchParameters: Parameter[],
    sortingParameters: Parameter[],
    currentPage: number,
    pageSize: number
  ): Promise<PaginatedList<DeliveryNoteUnsubmittedSearchResultDTO>> {
    try {
      var response = await APIService.Axios().post(
        `${APIService.GetURL()}/DeliveryNote/GetAllUnsubmited`,
        {
          searchParameters,
          sortingParameters,
          currentPage,
          pageSize,
        },
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + APIService.GetToken(),
          },
        }
      );
      return response.data;
    } catch (error) {
      return new PaginatedList<DeliveryNoteUnsubmittedSearchResultDTO>(
        false,
        "Erro ao ligar ao servidor ao obter a informação das Guias de Transporte Requisitadas",
        "",
        [],
        0
      );
    }
  }

  async GetById(
    id: string
  ): Promise<MessagingHelper<DeliveryNoteEditDTO | null>> {
    try {
      var response = await APIService.Axios().get(
        `${APIService.GetURL()}/DeliveryNote/GetAllUnsubmited/${id}`,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + APIService.GetToken(),
          },
        }
      );
      return response.data;
    } catch (error) {
      return new MessagingHelper<null>(
        false,
        "Erro ao ligar ao Servidor para obter a informação da Guia de transporte",
        null
      );
    }
  }
  async EditDeliveryNote(
    deliveryNoteEdit: DeliveryNoteEditDTO
  ): Promise<MessagingHelper<null>> {
    try {
      var response = await APIService.Axios().put(
        `${APIService.GetURL()}/DeliveryNote/EditDeliveryNote`,
        { ...deliveryNoteEdit },
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + APIService.GetToken(),
          },
        }
      );
      return response.data;
    } catch (error) {
      return new MessagingHelper<null>(
        false,
        "Erro ao ligar ao servidor para atualizar a Guia de Transporte",
        null
      );
    }
  }
}
